import React from 'react';
import { TableRow } from '@material-ui/core';

import Processos from './Processos';

function Abertura({ abertura }) {
  return (
    <>
      <TableRow>
        <Processos
          etapas="Mapeamento"
          status={abertura.mapeamento_status}
          encerramento={abertura.mapeamento_encerramento}
          observacao={abertura.mapeamento_observacao}
          observacao_interna={abertura.mapeamento_observacao_interna}
        />
      </TableRow>
      <TableRow>
        <Processos
          etapas="Elaboração Minuta Contratual"
          status={abertura.minuta_status}
          encerramento={abertura.minuta_encerramento}
          observacao={abertura.minuta_observacao}
          observacao_interna={abertura.minuta_observacao_interna}
        />
      </TableRow>
      <TableRow>
        <Processos
          etapas="Viabilidade"
          status={abertura.viabilidade_status}
          encerramento={abertura.viabilidade_encerramento}
          observacao={abertura.viabilidade_observacao}
          observacao_interna={abertura.viabilidade_observacao_interna}
        />
      </TableRow>
      <TableRow>
        <Processos
          etapas="DBE"
          status={abertura.dbe_status}
          encerramento={abertura.dbe_encerramento}
          observacao={abertura.dbe_observacao}
          observacao_interna={abertura.dbe_observacao_interna}
        />
      </TableRow>
      <TableRow>
        <Processos
          etapas="Certificado Bird ID"
          status={abertura.certificado_status}
          encerramento={abertura.certificado_encerramento}
          observacao={abertura.certificado_observacao}
          observacao_interna={abertura.certificado_observacao_interna}
        />
      </TableRow>
      <TableRow>
        <Processos
          etapas="Registro"
          status={abertura.registro_status}
          encerramento={abertura.registro_encerramento}
          observacao={abertura.registro_observacao}
          observacao_interna={abertura.registro_observacao_interna}
        />
      </TableRow>
      <TableRow>
        <Processos
          etapas="Inscrição Municipal"
          status={abertura.inscricao_municipal_status}
          encerramento={abertura.inscricao_municipal_encerramento}
          observacao={abertura.inscricao_municipal_observacao}
          observacao_interna={abertura.inscricao_municipal_observacao_interna}
        />
      </TableRow>
      <TableRow>
        <Processos
          etapas="Deferimento Simples Nacional"
          status={abertura.deferimento_simples_status}
          encerramento={abertura.deferimento_simples_encerramento}
          observacao={abertura.deferimento_simples_observacao}
          observacao_interna={abertura.deferimento_simples_observacao_interna}
        />
      </TableRow>
      <TableRow>
        <Processos
          etapas="Licenciamento"
          status={abertura.licenciamento_status}
          encerramento={abertura.licenciamento_encerramento}
          observacao={abertura.licenciamento_observacao}
          observacao_interna={abertura.licenciamento_observacao_interna}
        />
      </TableRow>
    </>
  );
}

export default Abertura;
